import script from "./PackageCardItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageCardItem.vue?vue&type=script&setup=true&lang=js"

import "./PackageCardItem.vue?vue&type=style&index=0&id=16235816&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16235816"]])

export default __exports__